import { render, staticRenderFns } from "./_order.vue?vue&type=template&id=5f854e00&"
import script from "./_order.vue?vue&type=script&lang=js&"
export * from "./_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports